import { HttpClient } from '@angular/common/http'
import { Injectable } from '@angular/core'
import { ConverterService, OccEndpointsService } from '@spartacus/core'
import { MbCheckoutQuoteInfoAdapter } from '../connectors/quote-info'
import { MbQuoteInfoModel } from '../../models'

@Injectable({
  providedIn: 'root',
})
export class MbOccCheckoutQuoteInfoAdapter implements MbCheckoutQuoteInfoAdapter {

  constructor (protected http: HttpClient,
               protected occEndpoints: OccEndpointsService,
               protected converter: ConverterService) {
  }

  post (quoteInfoDetails: MbQuoteInfoModel, cartId: string) {
    return this.http.post(this.getEndpoint(cartId), quoteInfoDetails)
  }

  protected getEndpoint (cartId: string) {
    return this.occEndpoints.buildUrl(
      'checkoutQuoteInfo',
      {
        urlParams: { cartId },
      }
    )
  }
}
